<template>
  <div class="piecesMobile h-screen">
    <div class="title flex items-center justify-between">
      <div class="flex items-center">
        {{ data?.name }}
      </div>
      <AiMark theme="mobile" style="transform: translateY(1px)" />
    </div>
    <div
      class="video-info mt-[20px] h-[calc(100%-280px)] flex-y-center justify-center"
      :class="!isHorizontal ? 'items-baseline' : ''"
    >
      <div
        class="bg-black rounded-[12px] overflow-hidden w-full"
        :class="!isHorizontal ? 'mx-[16px] wrapper ' : 'mx-[30px] h-full aspect-video '"
      >
        <div
          v-if="data?.banned_status === IBannedStatus.BANNED"
          class="banned flex items-center justify-center"
        >
          <div class="text-[12px] text-white text-center mt-[50px]">
            {{ $t('cheng-pian-ke-neng-she-ji-min-gan-xin-xi-bu-zhi-chi-cha-kan') }}
          </div>
        </div>
        <VideoPlayers
          v-else
          :url="data?.video_url"
          :poster="data?.cover_url"
          :muted="true"
          :autoplay="true"
          :controls="true"
          :loop="false"
          :noIcon="true"
        />
      </div>
      <div class="footer">
        <x-button v-if="isChinese()" theme="blank-primary" @click="() => showContactNew()">
          {{ $t('lian-xi-wo-men') }}
        </x-button>
        <x-button
          v-if="data?.banned_status !== IBannedStatus.BANNED"
          theme="blank-default"
          @click="() => handleCopy()"
        >
          {{ $t('fu-zhi-lian-jie-fen-xiang-gai-nei-rong') }}
        </x-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { IBannedStatus } from '~/api/interface/space';
import message from '~/components-mobile/atom/x-alert/index.ts';
import XButton from '~/components-mobile/atom/x-button.vue';
import AiMark from '~/components/ai-mark/index.vue';
import VideoPlayers from '~/features/publicize/videoPlayer.vue';
import { showContactNew } from '~/hooks/useModal/modals/contact';
import { isChinese } from '~/utils/area';
// import { copyToClipboard } from '~/utils/';

const { $t } = useNuxtApp();

const props = defineProps(['data']);

const isHorizontal = computed(() => props.data?.project_resolution === '1080x1920');

const handleCopy = () => {
  try {
    // copyToClipboard(location.href);
    message.success($t('fu-zhi-cheng-gong'));
  } catch (error) {
    console.warn('[Pieces] handleCopy error', error);

    message.error($t('wen-ben-fu-zhi-shi-bai'));
  }
};
</script>

<style lang="scss">
.piecesMobile {
  .more {
    background: #d4d9fc;
    position: fixed;
    top: 0;
    padding: 4px;
    width: 100%;
    text-align: center;
    color: #2e1d66;
    line-height: 24px;
    z-index: 1111111;
  }
  .wrapper {
    height: m-rem(194);
  }
  .title {
    @apply px-[16px] truncate;
    font-weight: var(--x-weight-medium, 500);
    font-size: 18px;
    color: var(--text-1);
    line-height: 24px;
    padding-top: 20px;
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: m-rem(20) m-rem(16);
  }
  .container-btn {
    background-size: 110px;
  }
}
</style>
